module.exports = __webpack_public_path__ + "media/images/sp/page_common/logo/logo_eight_black-1ca070633cfdd5e2a686039867d381ae.svg";